import styled from 'styled-components';
var width = 40;
var iconWidth = 24;
export var Inner = styled.button.withConfig({
  displayName: "Inner",
  componentId: "sc-u0ou0d-0"
})(["display:inline-block;width:", "px;height:", "px;border:2px solid ", ";border-radius:", ";cursor:pointer;color:", ";transition:border-color 0.15s ease;svg{width:", "px;height:", "px;vertical-align:middle;}&:hover{border-color:", ";svg{border-color:", ";}}"], width, width, function (_ref) {
  var theme = _ref.theme;
  return theme.colors.terciaryM;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.borderRadius;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.colors.uiDD;
}, iconWidth, iconWidth, function (_ref4) {
  var theme = _ref4.theme;
  return theme.colors.terciary;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.colors.primary;
});